export const taggedInputFrCATranslations = {
  taggedInputPlaceholder: "Ajouter un courriel…",
  taggedInputInvalidEmail: "Saisissez une adresse courriel valide.",
  taggedInputDuplicate: "« {{email}} » est déjà un destinataire.",
  taggedInputBlockedDomain:
    "Les domaines de courriel personnels ne sont pas permis. Utilisez une adresse professionnelle.",
  taggedInputLimit: "Vous avez atteint la limite de {{max}} destinataires.",
  taggedInputMore: "+{{count}} de plus",
  taggedInputShowLess: "Afficher moins",
  taggedInputRemove: "Retirer {{email}}",
  taggedInputRemoveInvalid: "Retirer {{email}}, adresse non livrable",
  taggedInputRecipients: "Destinataires",
  taggedInputCountNone: "Aucun destinataire",
  taggedInputCountOne: "1 destinataire",
  taggedInputCountMany: "{{count}} destinataires",
  taggedInputAdded: "{{email}} ajouté. {{total}}.",
  taggedInputAddedMany: "{{count}} destinataires ajoutés. {{total}}.",
  taggedInputAddedAll: "{{count}} destinataires ajoutés.",
  taggedInputRemoved: "{{email}} retiré. {{total}}.",
  taggedInputListName: "{{label}} : {{total}}",
};
